/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：687__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widgetName: "计步器",
    stepCount: "步数",
    startStepUpdate: "开始计步",
    stopStepUpdate: "停止计步",
    resetStepCount: "重置计数",
    onStepCountChange: "步数变化",
    onPedometerNotAvailable: "检测不可用",
    onPedometerPermissionFail: "请求权限失败"
  }
}
export { r }
